// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** French Polynesia */
const PF = /^(?:8[7-9]\d{6})$/;

export default PF;
